import { UIElement } from './uiElement';
import { IUIElementOptions } from '../../../interfaces/options';

export class Input<T> extends UIElement<T> {
	constructor(
		id: string,
		label: string,
		value: T | KnockoutObservable<T>,
		options?: IUIElementOptions
	) {
		super(id, label, value, options);
	}
}
